import AbstractDataBuilder from "../../core/AbstractDataBuilder";
import CheckAvailabilityNormalizersResolver from "./CheckAvailabilityNormalizersResolver";
export default class CheckAvailabilityDataBuilder extends AbstractDataBuilder {
    static create() {
        if (undefined === this.builderInstance) {
            this.builderInstance = new this(new CheckAvailabilityNormalizersResolver());
        }
        return this.builderInstance;
    }
}
